const LoaderSmall = () => {
  return (
    <div className="loader-container" id="loader">
      <div className="lds-dual-ring"></div>
    </div>
  );
};

export default LoaderSmall;
